import React from 'react';
import { describe, PropTypes } from '@elliemae/ds-props-helpers';
import { styled } from '@elliemae/ds-system';
import { Grid } from '@elliemae/ds-grid';

const Separator = styled(Grid)`
  border-top: ${({ theme, color, borderType }) => `${theme.colors[color[0]][color[1]]} 1px ${borderType}`};
  border-left: ${({ theme, color, borderType }) => `${theme.colors[color[0]][color[1]]} 1px ${borderType}`};
`;

const MobileSeparator = ({ color = ['neutral', '800'], direction = 'horizontal', type = 'solid', margin = 'xs' }) => {
  const orientation = direction === 'vertical' ? 'height' : 'width';
  const xORy = direction === 'vertical' ? 'mx' : 'my';
  const styles = {
    width: 0,
    height: 0,
    [orientation]: '100%',
    [xORy]: margin,
    borderType: type,
    color,
  };
  return <Separator {...styles} />;
};

const mobileSeparatorProps = {
  type: PropTypes.oneOf(['solid', 'dashed']).description('Style type of separator').defaultValue('solid'),
  direction: PropTypes.oneOf(['vertical', 'horizontal'])
    .description('Direction of the separator')
    .defaultValue('horizontal'),
  color: PropTypes.array.description('Color of the separator').defaultValue(['neutral', '800']),
  margin: PropTypes.oneOf(['xxs', 'xs', 's', 'm', 'l', 'xl', 'xxl'])
    .description('Margin of the separator')
    .defaultValue('xs'),
};

MobileSeparator.displayName = 'MobileSeparator';
const MobileSeparatorWithSchema = describe(MobileSeparator);
MobileSeparatorWithSchema.propTypes = mobileSeparatorProps;

export { MobileSeparatorWithSchema };
export default MobileSeparator;
